import './reviews.component.pug'
import './reviews.component.scss'

import { Swiper, Pagination, Scrollbar, Mousewheel } from 'swiper'
Swiper.use([Pagination, Scrollbar, Mousewheel])

document.querySelectorAll('.reviews').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 10,
    // cssMode: true,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: swiperElement.querySelector('.swiper-scrollbar'),
      draggable: true
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2
      }
    }
  })
})
